import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=358826cc&scoped=true"
var script = {}
import style0 from "./PublicFooter.vue?vue&type=style&index=0&id=358826cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358826cc",
  null
  
)

export default component.exports